package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.UserRepository

import dev.zacsweers.metro.Inject

@Inject
class DeleteUserUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(id: String): Result<Unit> {
        return userRepository.deleteUser(id)
    }
}
